import styled from 'styled-components';

export const Wrapper = styled.div`
  @media (min-width: 640px) {
    padding: 24px 16px 0px 16px;
  }

  @media (min-width: 768px) {
    padding: 24px 24px 0px 24px;
  }

  @media (min-width: 992px) {
    padding: calc(72px + 24px) 32px 0px calc(88px + 32px);
  }
`;
